var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 23.5 14.1",
    width: 23.5,
    height: 14.1,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1,10.4l-1.8,0c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6l1.8,0.1c0.3,0,0.6-0.3,0.6-0.6 C12.7,10.6,12.5,10.4,12.1,10.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4,12.7c-0.9,0.5-2.1,0.2-2.6-0.7c-0.5-0.9-0.2-2.1,0.7-2.6c0.9-0.5,2.1-0.2,2.6,0.7 C18.7,10.9,18.4,12.1,17.4,12.7 M15,8.4c-1.5,0.8-2,2.7-1.2,4.1c0.8,1.5,2.7,2,4.1,1.2c1.4-0.8,2-2.7,1.2-4.1 C18.4,8,16.5,7.5,15,8.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8,4L17,3.6c-0.7-0.1-1.3-0.4-1.7-0.9l-1-1.2c-0.7-0.9-1.7-1.3-2.8-1.4L7.6,0C7,0,6.3,0.1,5.7,0.4 C1.5,2.3,0.4,6.3,0,8.6c-0.1,1,0.4,2,1.2,2.5c0.3,0.1,0.6,0.1,0.8-0.2c0.1-0.3,0-0.6-0.2-0.7l0,0C1.4,9.8,1.1,9.3,1.2,8.7 c0.3-2.5,1.5-5.7,5-7.3c0.5-0.2,1-0.3,1.5-0.3l3.8,0.1c0.8,0,1.5,0.3,2,1l1,1.2c0.6,0.7,1.5,1.2,2.4,1.4l2.7,0.4 c0.9,0.1,1.6,0.6,2.1,1.4c0.5,0.8,0.7,1.7,0.7,2.6c-0.1,0.7-0.6,1.3-1.4,1.3c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 c0.4,0,0.9-0.1,1.3-0.3c0.8-0.4,1.3-1.2,1.3-2.1c0-1.1-0.2-2.2-0.8-3.2C22.1,4.9,21,4.1,19.8,4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7,12.6c-0.9,0.5-2.1,0.2-2.6-0.7c-0.5-0.9-0.2-2.1,0.7-2.6C6,8.7,7.2,9.1,7.7,10C8.2,10.9,7.9,12,7,12.6 M4.5,8.3c-1.5,0.8-2,2.7-1.2,4.1c0.8,1.5,2.7,2,4.1,1.2c1.5-0.8,2-2.7,1.2-4.1C7.9,7.9,6,7.4,4.5,8.3C4.6,8.2,4.6,8.2,4.5,8.3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/Parking.ed80d21cf7a3891c6d14b463547908d7.svg";
export { ForwardRef as ReactComponent };